import { largestCostChangesWidgetByIdSelector } from "./largestCostChangesWidgetByIdSelector";
import { largestCostChangesWidgetNotFoundSelector } from "./largestCostChangesWidgetNotFoundSelector";
import { RootState } from "../../../../store";
import { WidgetTitleProps } from "../../../../../components/pages/dashboard/components/widgets/common/widget-header/source-and-name/WidgetSourceInfo";
import { resourceExplorerViewNameByViewIdSelector } from "../../../../resource-explorer/selectors/all-resource-explorers/resourceExplorerViewNameByViewIdSelector";
import { resourceExplorerCloudProvidersByViewIdSelector } from "../../../../resource-explorer/selectors/all-resource-explorers/resourceExplorerCloudProvidersByViewIdSelector";
import { getResourcesExplorerGroupingLabel } from "../../../../../components/pages/resource-explorer/components/resource-explorer-card/utils/helpers/getResourcesExplorerGroupingLabel";
import { objectToUrl } from "../../../../../components/utils/helpers/dataToUrlToDataConvertors";

export const largestCostChangesWidgetTitlePropsSelector = (
  state: RootState,
  widgetId: string,
): WidgetTitleProps | null => {
  const widget = largestCostChangesWidgetByIdSelector(state, widgetId);

  if (!widget) {
    return null;
  }

  const viewName = resourceExplorerViewNameByViewIdSelector(
    state,
    widget.view_id,
  );

  const viewProviders =
    resourceExplorerCloudProvidersByViewIdSelector(state, widget.view_id) ?? [];

  const grouping = getResourcesExplorerGroupingLabel(
    viewProviders,
    widget.grouping,
    true,
  );

  const viewNotFound = largestCostChangesWidgetNotFoundSelector(
    state,
    widgetId,
  );

  const dates = {
    from: widget.date_from,
    to: widget.date_to,
    label: widget.date_label,
  };

  const path = objectToUrl([
    {
      groupedBy: widget.grouping,
      groupValues: widget.group_values,
      dates: dates,
      includedFilters: {},
    },
  ]);

  return {
    grouping,
    widgetName: widget.name,
    dates: {
      label: widget?.date_label,
      from: widget?.date_from,
      to: widget?.date_to,
    },
    sourceData: viewNotFound
      ? undefined
      : {
          icon: "pie",
          title: viewName ?? "",
          menu: [
            {
              title: "Open in Resource Explorer",
              url: `/resource-explorer/${widget.view_id}?path=${path}`,
            },
          ],
        },
  };
};
